export default {
  feedEnd: {
    id: 'feed.end.message',
    defaultMessage: "You've reached the end",
  },
};
